"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunDefenseGradeFacet = exports.RunGradeFacet = exports.PassGradeFacet = exports.CoverageGradeFacet = exports.ReceivingGradeFacet = exports.OverallGradeFacet = void 0;
/**
 * Overall grade analysis provided by PFF.
 */
var OverallGradeFacet;
(function (OverallGradeFacet) {
    OverallGradeFacet["Offense"] = "offense";
    OverallGradeFacet["Defense"] = "defense";
})(OverallGradeFacet || (exports.OverallGradeFacet = OverallGradeFacet = {}));
/**
 * Receiving grades provided by PFF.
 */
var ReceivingGradeFacet;
(function (ReceivingGradeFacet) {
    ReceivingGradeFacet["Receiving"] = "receiving";
    ReceivingGradeFacet["PassRouteMan"] = "man-pass-route";
    ReceivingGradeFacet["PassRouteZone"] = "zone-pass-route";
    ReceivingGradeFacet["HandsDropMan"] = "man-hands-drop";
    ReceivingGradeFacet["HandsDropZone"] = "zone-hands-drop";
})(ReceivingGradeFacet || (exports.ReceivingGradeFacet = ReceivingGradeFacet = {}));
/**
 * Coverage grades provided by PFF.
 */
var CoverageGradeFacet;
(function (CoverageGradeFacet) {
    CoverageGradeFacet["Coverage"] = "coverage";
    CoverageGradeFacet["CoverageMan"] = "man-coverage";
    CoverageGradeFacet["CoverageZone"] = "zone-coverage";
})(CoverageGradeFacet || (exports.CoverageGradeFacet = CoverageGradeFacet = {}));
/**
 * Pass grades provided by PFF.
 */
var PassGradeFacet;
(function (PassGradeFacet) {
    PassGradeFacet["Pass"] = "pass";
})(PassGradeFacet || (exports.PassGradeFacet = PassGradeFacet = {}));
/**
 * Run grades provided by PFF.
 */
var RunGradeFacet;
(function (RunGradeFacet) {
    RunGradeFacet["Run"] = "run";
})(RunGradeFacet || (exports.RunGradeFacet = RunGradeFacet = {}));
/**
 * Run defense grades provided by PFF.
 */
var RunDefenseGradeFacet;
(function (RunDefenseGradeFacet) {
    RunDefenseGradeFacet["RunDefense"] = "run-defense";
})(RunDefenseGradeFacet || (exports.RunDefenseGradeFacet = RunDefenseGradeFacet = {}));
//# sourceMappingURL=grade-facets.js.map